module.exports = __webpack_public_path__ + "img/5.5ddeec29.png";